// Story 8.1 (ADO-2010), AC4 / AC5: a store user chooses where to order before browsing.
// Enabler E8-G (ADO-3109), DA-10 (AC11): so does a staff user, who picks a store account.
//
// Wraps the product browsing routes (`/products`, `/products/:sku`, `/favourites`,
// `/landing`, `/cart`). When `requiresOrderingChoice` holds (a store user with entries to
// choose from and no active choice, or a staff user with no store account picked) it
// redirects to the choice screen, carrying the requested location in history state as
// `returnTo`; the choice screen returns there after the pick, so a deep link or a refresh
// still wins, only after the choice. An unlinked Shopper, a user with no entries and a
// session with no successful choices read are let through. A display / routing affordance
// only: the server re-checks the depot and the account of every basket call (D-A).

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useSessionStore } from '../auth/useSessionStore';
import { CHOOSE_ROUTE } from './orderingChoices';
import { requiresOrderingChoice } from './orderingSession';

export function RequireOrderingChoice({ children }: { children: ReactNode }) {
  const location = useLocation();
  const mustChoose = useSessionStore(requiresOrderingChoice);
  if (mustChoose) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={CHOOSE_ROUTE} replace state={{ returnTo }} />;
  }
  return children;
}
